import { initCopyDiscountCode } from '../../snippets/discount-code-promo/discount-code-promo';
import { initHelpSlider } from './discount-code-template-help/discount-code-template-help';
import { initSmartHomeSlider } from './discount-code-template-smart-home/discount-code-template-smart-home';
import YTPlayer from '../../scripts/components/YTPlayer';

initCopyDiscountCode();
initHelpSlider();
initSmartHomeSlider();
YTPlayer.init();
